export default __webpack_public_path__ + "static/03-2b33e8e410ea709d2c9cab49a773cd87.png";